export const getEmptyData = ()=>({
    child: {
      lastName: '',
      firstName: '',
      secondName: '',
      birthDate: new Date().toISOString(),
      gender: 'girl',
      birthCertificate: {
        seriesNumber: '',
        issueDate: new Date().toISOString(),
        country: 'ua',
        files:[]
      },
      addressYur: {
        district: '',
        street: '',
        building: '',
        corpus: ''
      },
      addressFact: {
        district: '',
        street: '',
        building: '',
        corpus: ''
      },
      sameFactAddress: "yes",
      address: "",
      isAddressKyiv: "yes",
      addressFactStr: ""
    },
    applicant: {
      lastName: '',
      firstName: '',
      middleName: '',
      citizenship: 'Україна',
      hasRnokpp: "yes",
      rnokpp: '',
      phone: '',
      email: '',
      address: {
        district: '',
        street: '',
        building: '',
        corpus: ''
      },
      documentType: '',
      documentDetails: '',
      addressStr: "",
      isAddressKyiv: "yes"

    },
    // В початковому стані форми додайте:
    preferences: {
        desiredDate: null,
        ageMenu: false,
        dissabilities: false,
        inclusiveGroup: false,
        withoutBed: false,      // Додати
        notWithoutBed: false,   // Додати
        languageTraining: 'uk', // Мова навчання за замовчуванням
        diseaseType: '',
        diseaseDocument: {
            type: '',
            number: '',
            issuedTo: '',
            issueDate: null,
            files: []
        }
    },
    benefits: {
      type: '',
      documentType: '',
      documentNumber: '',
      kindergarten:'',
      issuedTo: '',
      issueDate: '',
      files: [],
      address: {
        district: '',
        street: '',
        building: '',
        corpus: ''
      }
    },
    selectedSchools: [],
    agreePersonalData: "no",
    dictionary:{
      addresses:{ corpus:{}, building:{}, street:{}, district:{}},
      kindergartens:{}
    }
  })